import { Slider } from "@components/atoms/Slider"
import { Badge } from "@components/ui/Badge"
import { Chip } from "@components/ui/Chip"
import { cn, tv } from "@utils/tw"
import { ContentBlocks, defineBlock, EditableText } from "eddev/blocks"
import { Suspense } from "react"

export const meta: BlockMeta = {
  title: "Flexipasses",
  description: "Flexipasses",
  icon: "cart",
  category: "embed",
  tags: ["#homepage", "#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("homepage/homepage-flexipasses", (props) => {
  const styles = createStyles()

  return (
    <div data-mixpanel-block="Homepage Flexipass Slider">
      <div className={styles.base()}>
        <div className="flex md:hidden px-grid-gutter mb-8">
          <div className={cn(styles.info())}>
            <h2 className={styles.infoTag()}>
              <Chip variant="black">Flexipasses</Chip>
            </h2>
            <div className={styles.infoTitle()}>
              <EditableText as="p" store="title" placeholder="Enter a heading" plainText />
            </div>
            <div className={styles.infoDescription()}>
              <EditableText as="p" store="description" placeholder="Enter a description" />
            </div>
          </div>
        </div>

        <Slider gridInsert scrollerClass="flex gap-grid-gutter px-grid-gutter scroll-mask-start-0 !scroll-mask-inset-0">
          <div className={cn(styles.info(), "hidden md:flex")}>
            <h2 className={styles.infoTag()}>
              <Chip variant="black">Flexipasses</Chip>
            </h2>
            <div className={styles.infoTitle()}>
              <EditableText as="p" store="title" placeholder="Enter a heading" plainText />
            </div>
            <div className={styles.infoDescription()}>
              <EditableText as="p" store="description" placeholder="Enter a description" />
            </div>
          </div>
          <Suspense>
            <ContentBlocks
              blocks={props.templateParts?.globalFlexipasses?.contentBlocks}
              wrapBlock={(block) => <div className={styles.tile()}>{block}</div>}
            />
          </Suspense>
        </Slider>
      </div>
    </div>
  )
})

const createStyles = tv({
  base: "theme-dark bg-orange text-black py-grid-margin w-grid mx-auto",
  slots: {
    info: "w-cols-11 md:w-cols-4 flex-none snap-start flex flex-col",
    infoTag: "mb-4 md:mb-3",
    infoTitle: "-order-1 type-title-l flex-1 mb-5 md:mb-3 text-pretty lg:w-[10em]",
    infoDescription: "type-body-m md:type-body-m",
    tile: "w-cols-8 md:w-[calc(var(--tw-grid-inner-width)_/_4_-_(var(--tw-grid-gutter)_*_5)_/_4)] flex-none snap-start",
  },
})
